import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetIbFormDetailsRequestType,
  GetIbFormDetailsResponseType
} from '../../../services/FormsServices/APIService/types';

import { useFormsService } from '../useFormsService';

interface UseGetIbFormDetailsResponseInterface {
  getIbFormDetailsAPI: UseMutateAsyncFunction<
    GetIbFormDetailsResponseType,
    unknown,
    GetIbFormDetailsRequestType,
    unknown
  >;
  error: string;
  status: MutationStatus;
}

const useGetIbFormDetails = (): UseGetIbFormDetailsResponseInterface => {
  const { formsServiceAPI } = useFormsService();

  const getIbFormDetails = (request: GetIbFormDetailsRequestType) => {
    return formsServiceAPI.getIbFormDetails(request);
  };

  const { mutateAsync, error, status } = useMutation(getIbFormDetails, {
    mutationKey: ['getIbFormDetails']
  });

  return {
    getIbFormDetailsAPI: mutateAsync,
    error: error ? getAPIErrorMessage(error) : '',
    status
  };
};

export { useGetIbFormDetails };
